import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useDispatch, useSelector } from 'react-redux';
import UIDuck from 'src/redux/commonDucks/ui.duck';
import { IConfigurableCar } from 'src/interfaces/Car';
import { IDefaultConfigurationData, INameplateImage } from 'src/interfaces/IOfferItem';
import { ImageViewType } from '../constants/enums';

export const useGetGalleryImages = ({
    allowDefaultConfigurationImages,
}: {
    allowDefaultConfigurationImages?: boolean;
}) => {
    const { carDetails, defaultConfiguration } = useCarDetailsDuck();
    const dispatch = useDispatch();
    const imageViewType = useSelector((state) => UIDuck.getOwnState(state).imageViewType);

    const setImageViewType = (type: ImageViewType) => {
        dispatch(UIDuck.toggleImageViewType(type));
    };

    const carConfig: IConfigurableCar | IDefaultConfigurationData =
        allowDefaultConfigurationImages && defaultConfiguration ? defaultConfiguration : carDetails;
    const images = carConfig?.images?.filter((img) => img.type === imageViewType ?? [{}]);
    const mainImage = images?.splice(1, 1) ?? [{}];

    const imageItems = ([...mainImage, ...images] as Array<INameplateImage>).filter(
        (img) => !img.url.includes('&view=EXT') && !img.url.includes('&view=INT')
    );

    const isExterior = Boolean(carConfig?.images?.filter((img) => img.type === ImageViewType.EXTERIOR)?.length);
    const isInterior = Boolean(carConfig?.images?.filter((img) => img.type === ImageViewType.INTERIOR)?.length);

    const selectedImageViewType = imageViewType === ImageViewType.EXTERIOR ? 'ext' : 'int';

    const isSelectedExterior = imageViewType === ImageViewType.EXTERIOR;
    const isSelectedInterior = imageViewType === ImageViewType.INTERIOR;

    const isImagesExists = Boolean(Object.keys(imageItems?.[0] ?? {}).length);

    return {
        imageItems,
        imageViewType,
        isExterior,
        isInterior,
        selectedImageViewType,
        isSelectedExterior,
        isSelectedInterior,
        isImagesExists,
        setImageViewType,
    };
};
